/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiDropdownItemComponent from './UiDropdownItemComponent'
import { UiDropdownItem } from '../UiDropdown'

interface UiDropdownItemsListProps {
    items: UiDropdownItem[]
}

const UiDropdownItemsList = (props: UiDropdownItemsListProps) => {
    if (!props.items.length) {
        return null
    }

    return (
        <div className="UiDropdownItemsList">
            {props.items.map((item, index) => (
                <UiDropdownItemComponent key={index} item={item} />
            ))}
        </div>
    )
}

export default UiDropdownItemsList
